import React, {useEffect, useState} from 'react';

import styled from 'styled-components';

import {
  convertToBlob,
  LoadableImageEditor,
} from 'app/components/general/LoadablaImageEditor';
import {useAccountSettingsState} from 'app/settings/api';
import {preparedImageUploader, removeMediaPath} from 'app/utils/fineuploader';

import {AttachedMedia} from 'sweet-types';

export const StyledImageListUL = styled.ul.attrs({
  className: 'd-flex list-unstyled row',
})`
  margin-bottom: 0;

  .image {
    position: relative;

    .border {
      position: relative;

      .loading {
        font-size: 2rem;
        color: #fff;
        position: absolute;
      }
    }

    .delete-img {
      position: absolute;
      top: -12px;
      right: 3px;
      background: #fff;
      border: 2px solid #343838;
      border-radius: 1.5em;
      width: 27px;
      height: 27px;
      line-height: 0.9em;
      padding: 0 0 1px 0;
      text-align: center;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
    }
  }
`;
type Props = {
  images: Array<AttachedMedia>;
  onEditImage?: (newImageRef: string, arg1: number) => void;
  onRemoveImage: (arg0: AttachedMedia, arg1: number) => void;
};

export function EditableStepImagesGallery({
  images,
  onEditImage,
  onRemoveImage,
}: Props): JSX.Element | null {
  const [editing, setEditing] = useState<string | false>(false);
  const [editingIndex, setEditingIndex] = useState<null | number>(null);
  const [uploadingIndex, setUploadingIndex] = useState<null | number>(null);
  const [uploader, setUploader] = useState<any>(null);

  const {account_id, MEDIA_URL, s3Upload} = useAccountSettingsState().data!;

  useEffect(
    () =>
      setUploader(
        preparedImageUploader(s3Upload['IMAGES'], account_id, MEDIA_URL)
      ),
    []
  );

  if (images.length === 0) {
    return null;
  }

  const onImageClick = (image: any, imageURL: string, editingIndex: number) => {
    if (image.embed_html != null && image.image_ref == null) {
      // it's a video thumbnail and can't be changed
      return;
    }

    setEditing(imageURL);
    setEditingIndex(editingIndex);
  };

  const onExport = (imageDataURL: string) => {
    setEditing(false);
    setUploadingIndex(editingIndex);
    setEditingIndex(null);

    uploader.on('complete', handleComplete);

    if (typeof editing === 'string') {
      uploader.methods.addBlobs([
        {
          name: editing.split('/').pop(),
          blob: convertToBlob(imageDataURL),
        },
      ]);
    }
  };

  const handleComplete = (id: number, name: string, response: any): void => {
    if (response.success === true) {
      const imageRef = removeMediaPath(uploader.methods.getKey(id), MEDIA_URL);

      if (onEditImage != null && uploadingIndex != null) {
        onEditImage(imageRef, uploadingIndex);
      }
    }
    setUploadingIndex(null);
  };

  return (
    <div>
      <StyledImageListUL>
        {images.map((image, index) => {
          const imageURL =
            typeof image.image_ref === 'string' && image.image_ref !== ''
              ? `${MEDIA_URL}${image.image_ref}`
              : image.embed_thumb;
          const imageClass =
            typeof image.image_ref === 'string' && image.image_ref !== ''
              ? 'screenshot'
              : 'video-thumb';
          return (
            <li key={index} className="image col-12 col-sm-6 col-lg-3 mb-4">
              <div className="bg-secondary border border-secondary d-flex justify-content-center align-items-center">
                {index === uploadingIndex ? (
                  <i className="loading fa fa-circle-notch fa-spin" />
                ) : null}
                <img
                  className={`img-fluid ${imageClass}`}
                  src={imageURL}
                  onClick={() => onImageClick(image, imageURL, index)}
                />
              </div>
              <button
                className="btn btn-link delete-img"
                onClick={() => onRemoveImage(image, index)}
              >
                <i className="fa fa-times" />
              </button>
            </li>
          );
        })}
        {editing !== false ? (
          <LoadableImageEditor
            image={editing}
            show={true}
            onClose={() => setEditing(false)}
            onSave={onExport}
            onError={() => null}
          />
        ) : null}
      </StyledImageListUL>
    </div>
  );
}
